import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { mockSubmissions, mockKhatians, mockGadgetSubmissions } from '../data/mockData';
import { StatusBadge } from '../components/StatusBadge';
import { FileUp, CheckCircle, Clock, AlertTriangle, Database, FileText, FilePlus, RefreshCw, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Dashboard: React.FC = () => {
  const {
    user
  } = useAuth();
  // Calculate stats based on mock data
  const pendingValidation = mockSubmissions.filter(s => s.status === 'pending_validation').length;
  const processing = mockSubmissions.filter(s => s.status === 'processing').length;
  const readyApproval = mockSubmissions.filter(s => s.status === 'ready_for_approval').length;
  const published = mockSubmissions.filter(s => s.status === 'published').length;
  const totalKhatians = mockKhatians.length;
  // Gadget Stats
  const zsoGadgets = mockGadgetSubmissions.filter(g => g.submittedBy === 'ZSO Jamalpur' || g.submittedBy === 'ZSO Dhaka'); // Mocking current user's submissions
  const totalZsoGadgets = zsoGadgets.length;
  const pendingZsoGadgets = zsoGadgets.filter(g => g.status === 'submitted').length;
  const approvedZsoGadgets = zsoGadgets.filter(g => g.status === 'approved' || g.status === 'published').length;
  const returnedZsoGadgets = zsoGadgets.filter(g => g.status === 'returned').length;
  const totalDsGadgets = mockGadgetSubmissions.length;
  const pendingDsGadgets = mockGadgetSubmissions.filter(g => g.status === 'submitted').length;
  const approvedDsGadgets = mockGadgetSubmissions.filter(g => g.status === 'approved').length;
  const publishedDsGadgets = mockGadgetSubmissions.filter(g => g.status === 'published').length;
  const StatCard = ({
    title,
    value,
    icon: Icon,
    colorClass,
    link
  }: any) => <div className="card p-6 flex items-center" data-id="element-353">
      <div className={`p-4 rounded-full ${colorClass} mr-4`} data-id="element-354">
        <Icon size={24} data-id="element-355" />
      </div>
      <div className="flex-1" data-id="element-356">
        <h3 className="text-sm font-medium text-slate-500" data-id="element-357">{title}</h3>
        <p className="text-2xl font-bold text-slate-900" data-id="element-358">{value}</p>
      </div>
      {link && <Link to={link} className="text-sm font-medium text-teal-600 hover:text-teal-800" data-id="element-359">
          দেখুন
        </Link>}
    </div>;
  const renderRoleSpecificContent = () => {
    switch (user?.role) {
      case 'operator':
        return <>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-360">
              <StatCard title="আমার দাখিলসমূহ" value="১২" icon={FileUp} colorClass="bg-blue-100 text-blue-600" link="/upload" data-id="element-361" />
              <StatCard title="যাচাইয়ের অপেক্ষায়" value={pendingValidation} icon={Clock} colorClass="bg-amber-100 text-amber-600" data-id="element-362" />
              <StatCard title="প্রকাশিত" value={published} icon={CheckCircle} colorClass="bg-teal-100 text-teal-600" data-id="element-363" />
            </div>
            <div className="card p-6" data-id="element-364">
              <div className="flex justify-between items-center mb-4" data-id="element-365">
                <h2 className="text-lg font-semibold text-slate-800" data-id="element-366">
                  সাম্প্রতিক দাখিলসমূহ
                </h2>
                <Link to="/upload" className="btn-primary text-sm" data-id="element-367">
                  নতুন দাখিল
                </Link>
              </div>
              <RecentSubmissionsTable limit={5} data-id="element-368" />
            </div>
          </>;
      case 'zso':
        return <>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-369">
              <StatCard title="মোট গেজেট জমাদান" value={totalZsoGadgets} icon={FileUp} colorClass="bg-blue-100 text-blue-600" link="/gadget/submissions" data-id="element-370" />
              <StatCard title="অনুমোদনের অপেক্ষায়" value={pendingZsoGadgets} icon={Clock} colorClass="bg-amber-100 text-amber-600" data-id="element-371" />
              <StatCard title="অনুমোদিত" value={approvedZsoGadgets} icon={CheckCircle} colorClass="bg-teal-100 text-teal-600" data-id="element-372" />
              <StatCard title="ফেরত এসেছে" value={returnedZsoGadgets} icon={RefreshCw} colorClass="bg-red-100 text-red-600" data-id="element-373" />
            </div>
            <div className="card p-6" data-id="element-374">
              <div className="flex justify-between items-center mb-4" data-id="element-375">
                <h2 className="text-lg font-semibold text-slate-800" data-id="element-376">
                  সাম্প্রতিক গেজেট জমাদান
                </h2>
                <Link to="/gadget/new" className="btn-primary text-sm" data-id="element-377">
                  নতুন গেজেট প্রস্তুতি
                </Link>
              </div>
              <RecentGadgetSubmissionsTable data={zsoGadgets} limit={5} data-id="element-378" />
            </div>
          </>;
      case 'officer':
        return <>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-379">
              <StatCard title="যাচাইয়ের অপেক্ষায়" value={pendingValidation} icon={AlertTriangle} colorClass="bg-amber-100 text-amber-600" link="/validate" data-id="element-380" />
              <StatCard title="প্রক্রিয়াধীন" value={processing} icon={Database} colorClass="bg-blue-100 text-blue-600" link="/processing" data-id="element-381" />
              <StatCard title="আজ পর্যালোচনা করা হয়েছে" value="৮" icon={CheckCircle} colorClass="bg-emerald-100 text-emerald-600" data-id="element-382" />
            </div>
            <div className="card p-6" data-id="element-383">
              <h2 className="text-lg font-semibold text-slate-800 mb-4" data-id="element-384">
                পদক্ষেপ প্রয়োজন
              </h2>
              <RecentSubmissionsTable filterStatus="pending_validation" limit={5} data-id="element-385" />
            </div>
          </>;
      case 'admin':
        return <>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-386">
              <StatCard title="অনুমোদনের জন্য প্রস্তুত" value={readyApproval} icon={ShieldCheckIcon} colorClass="bg-indigo-100 text-indigo-600" link="/approve" data-id="element-387" />
              <StatCard title="প্রক্রিয়াধীন" value={processing} icon={Database} colorClass="bg-blue-100 text-blue-600" link="/processing" data-id="element-388" />
              <StatCard title="মোট প্রকাশিত" value={published} icon={CheckCircle} colorClass="bg-teal-100 text-teal-600" data-id="element-389" />
              <StatCard title="মোট খতিয়ান" value={totalKhatians * 1000} icon={FileText} colorClass="bg-slate-100 text-slate-600" link="/viewer" data-id="element-390" />
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-391">
              <div className="card p-6" data-id="element-392">
                <h2 className="text-lg font-semibold text-slate-800 mb-4" data-id="element-393">
                  অপেক্ষমাণ অনুমোদন
                </h2>
                <RecentSubmissionsTable filterStatus="ready_for_approval" limit={5} data-id="element-394" />
              </div>
              <div className="card p-6" data-id="element-395">
                <h2 className="text-lg font-semibold text-slate-800 mb-4" data-id="element-396">
                  সিস্টেম স্ট্যাটাস
                </h2>
                <div className="space-y-4" data-id="element-397">
                  <div className="flex justify-between items-center p-3 bg-slate-50 rounded-md border border-slate-100" data-id="element-398">
                    <span className="text-sm font-medium text-slate-700" data-id="element-399">
                      মিডলওয়্যার সার্ভিস
                    </span>
                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800" data-id="element-400">
                      সক্রিয়
                    </span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-slate-50 rounded-md border border-slate-100" data-id="element-401">
                    <span className="text-sm font-medium text-slate-700" data-id="element-402">
                      ডিএলএমএস সিঙ্ক
                    </span>
                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800" data-id="element-403">
                      সক্রিয়
                    </span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-slate-50 rounded-md border border-slate-100" data-id="element-404">
                    <span className="text-sm font-medium text-slate-700" data-id="element-405">
                      স্টোরেজ ক্ষমতা
                    </span>
                    <div className="w-1/2 bg-slate-200 rounded-full h-2.5" data-id="element-406">
                      <div className="bg-blue-600 h-2.5 rounded-full" style={{
                      width: '45%'
                    }} data-id="element-407"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>;
      case 'dsminland':
        return <>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-408">
              <StatCard title="মোট প্রাপ্ত গেজেট" value={totalDsGadgets} icon={FileText} colorClass="bg-blue-100 text-blue-600" link="/gadget/ds-submissions" data-id="element-409" />
              <StatCard title="অনুমোদনের অপেক্ষায়" value={pendingDsGadgets} icon={Clock} colorClass="bg-amber-100 text-amber-600" link="/gadget/approve" data-id="element-410" />
              <StatCard title="অনুমোদিত" value={approvedDsGadgets} icon={ShieldCheck} colorClass="bg-indigo-100 text-indigo-600" data-id="element-411" />
              <StatCard title="প্রজ্ঞাপন প্রকাশিত" value={publishedDsGadgets} icon={CheckCircle} colorClass="bg-teal-100 text-teal-600" data-id="element-412" />
            </div>
            <div className="card p-6" data-id="element-413">
              <div className="flex justify-between items-center mb-4" data-id="element-414">
                <h2 className="text-lg font-semibold text-slate-800" data-id="element-415">
                  অপেক্ষমাণ গেজেট অনুমোদন
                </h2>
                <Link to="/gadget/approve" className="btn-primary text-sm" data-id="element-416">
                  অনুমোদন প্যানেল
                </Link>
              </div>
              <RecentGadgetSubmissionsTable data={mockGadgetSubmissions.filter(g => g.status === 'submitted')} limit={5} data-id="element-417" />
            </div>
          </>;
      default:
        return null;
    }
  };
  return <div className="max-w-7xl mx-auto" data-id="element-418">
      <div className="mb-8" data-id="element-419">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-420">
          স্বাগতম, {user?.name}
        </h1>
        <p className="text-slate-500" data-id="element-421">{user?.designation}</p>
      </div>
      {renderRoleSpecificContent()}
    </div>;
};
// Helper component for the dashboard
const ShieldCheckIcon = (props: any) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-422">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" data-id="element-423" />
    <path d="m9 12 2 2 4-4" data-id="element-424" />
  </svg>;
const RecentSubmissionsTable = ({
  filterStatus,
  limit
}: {
  filterStatus?: string;
  limit: number;
}) => {
  let data = mockSubmissions;
  if (filterStatus) {
    data = data.filter(s => s.status === filterStatus);
  }
  data = data.slice(0, limit);
  return <div className="overflow-x-auto" data-id="element-425">
      <table className="min-w-full divide-y divide-slate-200" data-id="element-426">
        <thead className="bg-slate-50" data-id="element-427">
          <tr data-id="element-428">
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-429">
              আইডি
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-430">
              অবস্থান
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-431">
              খতিয়ান সংখ্যা
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-432">
              তারিখ
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-433">
              স্ট্যাটাস
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-slate-200" data-id="element-434">
          {data.map(sub => <tr key={sub.id} className="hover:bg-slate-50" data-id="element-435">
              <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-slate-900" data-id="element-436">
                {sub.id}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500" data-id="element-437">
                {sub.mouja}, {sub.upazila}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500" data-id="element-438">
                {sub.khatianCount}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500" data-id="element-439">
                {new Date(sub.submittedAt).toLocaleDateString('bn-BD')}
              </td>
              <td className="px-4 py-3 whitespace-nowrap" data-id="element-440">
                <StatusBadge status={sub.status} data-id="element-441" />
              </td>
            </tr>)}
          {data.length === 0 && <tr data-id="element-442">
              <td colSpan={5} className="px-4 py-8 text-center text-sm text-slate-500" data-id="element-443">
                কোন রেকর্ড পাওয়া যায়নি।
              </td>
            </tr>}
        </tbody>
      </table>
    </div>;
};
const GadgetStatusBadge = ({
  status
}: {
  status: string;
}) => {
  switch (status) {
    case 'draft':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800" data-id="element-444">
          খসড়া
        </span>;
    case 'submitted':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-445">
          জমাদান করা হয়েছে
        </span>;
    case 'approved':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-446">
          অনুমোদিত
        </span>;
    case 'returned':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800" data-id="element-447">
          ফেরত
        </span>;
    case 'published':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-teal-100 text-teal-800" data-id="element-448">
          প্রকাশিত
        </span>;
    default:
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800" data-id="element-449">
          {status}
        </span>;
  }
};
const RecentGadgetSubmissionsTable = ({
  data,
  limit
}: {
  data: any[];
  limit: number;
}) => {
  const displayData = data.slice(0, limit);
  return <div className="overflow-x-auto" data-id="element-450">
      <table className="min-w-full divide-y divide-slate-200" data-id="element-451">
        <thead className="bg-slate-50" data-id="element-452">
          <tr data-id="element-453">
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-454">
              আইডি
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-455">
              অবস্থান
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-456">
              মৌজা সংখ্যা
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-457">
              তারিখ
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-458">
              স্ট্যাটাস
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-slate-200" data-id="element-459">
          {displayData.map(sub => <tr key={sub.id} className="hover:bg-slate-50" data-id="element-460">
              <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-slate-900" data-id="element-461">
                {sub.id}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500" data-id="element-462">
                {sub.district}, {sub.upazila}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500" data-id="element-463">
                {sub.moujaDetails?.length || 0}
              </td>
              <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500" data-id="element-464">
                {new Date(sub.submittedAt).toLocaleDateString('bn-BD')}
              </td>
              <td className="px-4 py-3 whitespace-nowrap" data-id="element-465">
                <GadgetStatusBadge status={sub.status} data-id="element-466" />
              </td>
            </tr>)}
          {displayData.length === 0 && <tr data-id="element-467">
              <td colSpan={5} className="px-4 py-8 text-center text-sm text-slate-500" data-id="element-468">
                কোন রেকর্ড পাওয়া যায়নি।
              </td>
            </tr>}
        </tbody>
      </table>
    </div>;
};